import Loading from '@/pages/extra/loading.vue';
import { RouteConfig } from 'vue-router';
import { ROUTE_NAME } from './constant';

export const routes: RouteConfig[] = [
    {
        path: '/dream/:activityId',
        name: ROUTE_NAME.DREAM_INDEX,
        meta: {
            title: '追梦中国',
            needBinding: true,
            needLoginNext: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/index.vue'),
    },
    {
        path: '/dream/detail/:activityId',
        name: ROUTE_NAME.DREAM_DETAIL,
        meta: {
            title: '赛事详情',
            needBinding: true,
            needLoginNext: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/detail.vue'),
    },
    {
        path: '/dream/runners/:activityId',
        name: ROUTE_NAME.DREAM_RUNNERS,
        meta: {
            title: '报名人数',
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/runners.vue'),
    },
    {
        path: '/dream/home/strategy',
        name: ROUTE_NAME.DREAM_STRATEGY,
        meta: {
            title: '追梦中国',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/strategy.vue'),
    },
    {
        path: '/dream/home/collection',
        name: ROUTE_NAME.DREAM_COLLECTION,
        meta: {
            title: '追梦中国',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/collection.vue'),
    },
    {
        path: '/dream/home/:activityId',
        name: ROUTE_NAME.DREAM_HOME,
        meta: {
            title: '追梦中国',
            needBinding: true,
            keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/home.vue'),
    },
    {
        path: '/dream/city/map/:cityId/:activityId',
        name: ROUTE_NAME.DREAM_CITYMAP,
        meta: {
            title: '追梦中国',
            needBinding: true,
            // keepAlive: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/cityMap.vue'),
    },
    {
        path: '/dream/scene/:activityId/:landmarkId/:cityId',
        name: ROUTE_NAME.DREAM_SCENE,
        meta: {
            title: '景观详情',
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/scene.vue'),
    },
    {
        path: '/dream/rank/index/:activityId/:type?',
        name: ROUTE_NAME.DREAM_RANK,
        meta: {
            title: '排行榜',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/ranking.vue'),
    },
    {

        path: '/dream/atlas/:activityId',
        name: ROUTE_NAME.DREAM_ATLAS,
        meta: {
            title: '我的图鉴',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/atlas.vue'),
    },
    {
        path: '/dream/history/:activityId',
        name: ROUTE_NAME.DREAM_HISTORY,
        meta: {
            title: '历史记录',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/history.vue'),
    },
    {
        path: '/dream/route/detail/:id',
        name: ROUTE_NAME.DREAM_ROUTE_DETAIL,
        meta: {
            title: '路线详情',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/routeDetail.vue'),
    },
    {
        path: '/dream/real_name_verify/:activityId',
        name: ROUTE_NAME.DREAM_REAL_NAME_VERIFY,
        meta: {
            title: '实名认证',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/realnameVerify.vue'),
    },
    {
        path: '/dream/digital/detail/:id',
        name: ROUTE_NAME.DREAM_DIGITAL_DETAIL,
        meta: {
            title: '藏品详情',
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/digitalDetail.vue'),
    },
    {
        path: '/dream/special/rank/:activityId',
        name: ROUTE_NAME.DREAM_SPECIAL_RANK,
        meta: {
            title: '排行榜',
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/specialRank.vue'),
    },
    {
        path: '/dream/join/:activityId/:specialId',
        name: ROUTE_NAME.DREAM_JOIN,
        meta: {
            title: '追梦中国',
            needLogin: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/join.vue'),
    },
    {
        path: '/dream/invite/:activityId',
        name: ROUTE_NAME.DREAM_INVITE,
        meta: {
            title: '邀请有礼',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/invite.vue'),
    },
    {
        path: '/dream/invite_self/:activityId',
        name: ROUTE_NAME.DREAM_INVITE_SELF,
        meta: {
            title: '我的邀请',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/inviteSelf.vue'),
    },
    {
        path: '/dream/invite_rank/:activityId',
        name: ROUTE_NAME.DREAM_INVITE_RANK,
        meta: {
            title: '邀请排行榜',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/inviteRank.vue'),
    },
    {
        path: '/dream/digital/share/:activityId/:type?',
        name: ROUTE_NAME.DREAM_DIGITAL,
        meta: {
            title: '追梦中国',
            needBinding: true,
        },
        component: () => import(/* webpackChunkName: "dream" */ './pages/digital.vue'),
    },
];
